import { Box, Flex, Typography } from '@ergolabs/ui-kit';
import { DateTime, Interval } from 'luxon';
import { Duration } from 'luxon/src/duration';
import React, { FC } from 'react';
import FlipNumbers from 'react-flip-numbers';

import { applicationConfig } from '../../applicationConfig';

interface TimerItemProps {
  readonly value: number;
}

const TimerItem: FC<TimerItemProps> = ({ value }) => {
  const formattedValue = value.toString().length === 2 ? value : `0${value}`;
  return <>{formattedValue}</>;
};

export interface RoundTimerProps {
  readonly duration: Duration;
}

export const Timer: FC<RoundTimerProps> = ({ duration }) => (
  <Typography.Title level={1}>
    <Flex align="center" gap={4}>
      <Box padding={4} secondary borderRadius="l">
        <FlipNumbers
          numbers={String(
            duration.hours.toString().length === 2
              ? duration.hours
              : `0${duration.hours}`,
          )}
          play
          color="#DBDBDB"
          perspective={100}
          height={16}
          width={13}
        />
      </Box>
      <Flex.Item>:</Flex.Item>
      <Box padding={4} secondary borderRadius="l">
        <FlipNumbers
          numbers={String(
            duration.minutes.toString().length === 2
              ? duration.minutes
              : `0${duration.minutes}`,
          )}
          play
          color="#DBDBDB"
          perspective={100}
          height={16}
          width={13}
        />
      </Box>
      <Flex.Item>:</Flex.Item>

      <Box padding={4} secondary borderRadius="l">
        <FlipNumbers
          numbers={String(
            duration.seconds.toString().length === 2
              ? duration.seconds
              : `0${duration.seconds}`,
          )}
          play
          color="#DBDBDB"
          perspective={100}
          height={16}
          width={13}
        />
      </Box>
    </Flex>
  </Typography.Title>
);

const StartTimer: FC = () => {
  return (
    <Flex align="center" justify="center" style={{ height: '100%' }}>
      <Box padding={4} secondary borderRadius="l">
        <Flex col>
          <Flex justify="center" direction="col">
            <Typography.Title
              level={3}
              style={{
                fontSize: '20px',
                textAlign: 'center',
                marginBottom: '8px',
              }}
            >
              Evaluating results
            </Typography.Title>
            <Typography.Body align="center">
              You will be able to claim your SPF in
            </Typography.Body>
          </Flex>

          <Flex.Item marginTop={4}>
            <Typography.Paragraph>
              <Timer
                duration={Interval.fromDateTimes(
                  DateTime.now(),
                  DateTime.utc(2023, 2, 15, 6, 0),
                ).end.diff(DateTime.now(), [
                  'hours',
                  'minutes',
                  'seconds',
                  'milliseconds',
                ])}
              />
            </Typography.Paragraph>
          </Flex.Item>
        </Flex>
      </Box>
    </Flex>
  );
};

export default StartTimer;
